type ActorIdentity = {
  personId?: number;
  requesterPersonId?: number;
  primaryOwnerPersonId?: number;
};

export const withoutActorIdentity = <T extends object>(request: T): Omit<T, keyof ActorIdentity> => {
  const payload = { ...request } as T & ActorIdentity;
  delete payload.personId;
  delete payload.requesterPersonId;
  delete payload.primaryOwnerPersonId;
  return payload;
};
